import useAsyncEffect from "../../hooks/useAsyncEffect";
import {useContext, useState} from "react";
import WatsonApi from "../../backends/WatsonApi";
import {StoreContext} from "../../stores/StoreLoader";
import NotificationManager from "../../components/notifications/NotificationManager";

export function EmailSubscriptions(props: {
    userObj: IPersonBlock
}) {
    const {organizationStore} = useContext(StoreContext);

    const [settingsChanged, setSettingsChanged] = useState(false);
    const [unsubscribeAll, setUnsubscribeAll] = useState(false);
    const [subscriptions, setSubscriptions] = useState<IEmailSubscription[]>([]);
    const [subscriptionSettings, setSubscriptionSettings] = useState({});

    useAsyncEffect(async () => {
        const client = await WatsonApi();
        const response = await client.apis.email_subscription.email_subscription_list();
        const subs = JSON.parse(response.data).data;
        setSubscriptions(subs);
        setSubscriptionSettings(subs.reduce((acc, curr) => {
            acc[curr.id] = props.userObj.blockModel.email_subscription_ids?.includes(curr.id);
            return acc;
        }, {}))
    }, [])

    async function handleSubmitNotificationSettings() {
        try {
            const client = await WatsonApi();
            await client.apis.organizations.organizations_users_partial_update({
                organization_pk: organizationStore.organization.id,
                id: props.userObj.blockModel.id,
                data: {
                    email_subscription_ids: unsubscribeAll ? [] : Object.entries(subscriptionSettings)
                        .filter(([k, v]) => v)
                        .map(([k, v]) => k)
                }
            })
            NotificationManager.success("Mailing list settings successfully updated!");
        } catch (e) {
            NotificationManager.error("An error occurred. Please try again.");
        }
    }

    async function handleUnsubscribeAll() {
        setSettingsChanged(true);
        setSubscriptionSettings(Object.fromEntries(Object.keys(subscriptionSettings).map(id => ([id, false]))));
        setUnsubscribeAll(v => !v);
    }

    return <div id="my-notification-settings-tab">
        <div className="sb-settings-block-content-heading">
            <h4>Mailing List Settings</h4>
            <div id="notification-settings-form">
                {subscriptions.map(subscription => {
                    return <div className="row subscription-item">
                        <div className="col-sm-12">
                            <div className="well">
                                <input type="checkbox" value="1"
                                       id={`subscriptions-${subscription.id}`}
                                       className="checkbox-default-links js-subscription-item"
                                       checked={subscriptionSettings[subscription.id]}
                                       onChange={() => {
                                           setSettingsChanged(true);
                                           setSubscriptionSettings(v => ({
                                               ...v,
                                               [subscription.id]: !v[subscription.id],
                                           }))
                                       }}
                                />&nbsp;
                                <label htmlFor={`subscriptions-${subscription.id}`}
                                       className="subscription-name">{
                                    subscription.name}</label>
                                <p className="subscription-description">{subscription.description}</p>
                            </div>
                        </div>
                    </div>
                })}
                <div className="row unsubscribe-item">
                    <div className="col-sm-12">
                        <label>Or check here to never receive any emails:</label>
                        <br/>
                        <input type="checkbox" onChange={handleUnsubscribeAll} checked={unsubscribeAll}
                               id="unsubscribe-all"
                               className="js-unsubscribe-all"/>&nbsp;
                        <label htmlFor="unsubscribe-all">Unsubscribe me from all mailing lists.</label>
                    </div>
                </div>
                <div className="sb-settings-block-footer">
                    <button type="submit" className="btn sb-organization-color-element-bg" name="submit"
                            disabled={!settingsChanged}
                            onClick={handleSubmitNotificationSettings}
                    >Update Mail List Settings
                    </button>
                </div>
            </div>
        </div>
    </div>
}